import { render, staticRenderFns } from "./PayrollClasification.vue?vue&type=template&id=38bc21ee&"
import script from "./PayrollClasification.vue?vue&type=script&lang=js&"
export * from "./PayrollClasification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports